;(function () {
  'use strict'

  angular
    .module('admin.user_segmentation.service', [])
    .factory('UserSegmentationService', UserSegmentationService)

  /** @ngInject */
  function UserSegmentationService($http, $q, API) {
    function listActive(start, limit, type, title, sort) {
      var defered = $q.defer()
      title = encodeURIComponent(title)
      $http
        .get(
          API.API_URL +
            'admin/user_segments/active?k=' +
            type +
            '&txt=' +
            title +
            '&start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort,
        )
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listArchived(start, limit, type, title, sort) {
      var defered = $q.defer()
      title = encodeURIComponent(title)
      $http
        .get(
          API.API_URL +
            'admin/user_segments/archived?k=' +
            type +
            '&txt=' +
            title +
            '&start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort,
        )
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listSnapshots(start, limit, snapshotted) {
      var defered = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/user_segments/snapshots?snapshotted=' +
            snapshotted +
            '&start=' +
            start +
            '&limit=' +
            limit,
        )
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listSnapshotsUnscheduled(start, limit) {
      var defered = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/user_segments/snapshots/unscheduled?&start=' +
            start +
            '&limit=' +
            limit,
        )
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listAll() {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/user_segments')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listUserBySegmentation(id, start, limit) {
      var defered = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/user_segments/' +
            id +
            '/users?start=' +
            start +
            '&limit=' +
            limit +
            '&sort=id-desc',
        )
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listUserBySegmentationWithoutPagination(id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/user_segments/' + id + '/users?sort=id-desc')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listBundles(id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/sets/' + id + '/bundles')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function get(id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/user_segments/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function getByIds(ids) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/user_segments/ids?ids=' + ids)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function save(model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/user_segments', model)
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, '', 'error')
        })

      return defered.promise
    }

    function clone(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/user_segments/' + id + '/clone')
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, '', 'error')
        })

      return defered.promise
    }

    function update(id, model) {
      var defered = $q.defer()

      $http
        .put(API.API_URL + 'admin/user_segments/' + id, model)
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, '', 'error')
        })

      return defered.promise
    }

    function remove(id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'admin/user_segments/' + id)
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, '', 'error')
        })

      return defered.promise
    }

    function getSet(id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/sets/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function getBundle(id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/bundles/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listAssociate(id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/user_segments/' + id + '/associated_items')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function matchUserSegment(userId, id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/user_segments/' + id + '/users/' + userId)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listBundleByIds(ids) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/bundles/ids?ids=' + ids)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listCollectibleByIds(ids) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/collectibles/ids?ids=' + ids)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listShinyByIds(ids) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/shinies/ids?ids=' + ids)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listCollectibles(id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/sets/' + id + '/collectibles')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listSetsByID(ids) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/sets/ids?setIds=' + ids)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function getChannelID(id) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'admin/channels/' + id).success(defered.resolve)

      return defered.promise
    }

    function listDrops() {
      var defered = $q.defer()

      $http.get(API.API_URL + 'publisher/drops/published').success(defered.resolve)

      return defered.promise
    }

    return {
      listActive: listActive,
      listArchived: listArchived,
      listAll: listAll,
      listBundleByIds: listBundleByIds,
      listUserBySegmentation: listUserBySegmentation,
      listUserBySegmentationWithoutPagination: listUserBySegmentationWithoutPagination,
      get: get,
      save: save,
      update: update,
      remove: remove,
      getSet: getSet,
      getBundle: getBundle,
      listBundles: listBundles,
      listAssociate: listAssociate,
      listCollectibleByIds: listCollectibleByIds,
      listShinyByIds: listShinyByIds,
      listSetsByID: listSetsByID,
      listCollectibles: listCollectibles,
      listSnapshots: listSnapshots,
      getChannelID: getChannelID,
      matchUserSegment,
      getByIds,
      clone,
      listDrops,
      listSnapshotsUnscheduled,
    }
  }
})()
